import arrowRightIcon from "@assets/media/images/icon-arrow-right.svg";
const SlickArrowRight = ({ ...props }) => (
  <div onClick={props.onClick} className={`cs-slick-arrow arrow-right ${props.onClick ? '' : 'disabled'}`}>
    <img src={arrowRightIcon} alt="" />
  </div>
);

export default SlickArrowRight;